const SERVER_URL = process.env.NEXT_PUBLIC_SERVER_URL;
const ORDER_ENGINE = process.env.NEXT_PUBLIC_ORDER_ENGINE;
const ORDER_ENGINE2 =
  process.env.NEXT_PUBLIC_ORDER_ENGINE2 ||
  "https://apis-devordersystem.paraacrypto.com/";
const ORDER_ENGINE3 =
  process.env.NEXT_PUBLIC_ORDER_ENGINE3 ||
  "https://apis-devordersystem.paraacrypto.com/";

module.exports = {
  SERVER_URL,
  ORDER_ENGINE,
  ORDER_ENGINE2,
  ORDER_ENGINE3,
};
